// PB-013 — Identità stabile della sessione di allenamento.
//
// Ogni sessione REALE (scheda o libero) riceve un UUID UNA SOLA VOLTA, salvato
// in localStorage insieme allo stato della sessione: sopravvive a reload, retry,
// timeout e background, e muore solo col clear della sessione (post-salvataggio
// riuscito o uscita volontaria). Il DB lo usa come chiave di idempotency:
// UNIQUE (athlete_id, client_session_id) → retry = stessa sessione, mai duplicati.

/** UUID v4. Preferisce crypto.randomUUID; fallback su getRandomValues (webview datate). */
export const newClientSessionId = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (e) { /* fallback sotto */ }
  try {
    const b = new Uint8Array(16);
    crypto.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40; // version 4
    b[8] = (b[8] & 0x3f) | 0x80; // variant 10
    const h = [...b].map((x) => x.toString(16).padStart(2, '0'));
    return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
  } catch (e) {
    // Ultimo fallback (nessuna crypto API): non crittografico ma forma v4 valida
    // e unico in pratica (Math.random + tempo).
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
};
